export default __webpack_public_path__ + "static/media/marauders-map-v1-01-01.91ba003c.jpg";